import { render, staticRenderFns } from "./OvertimeManagementComponent.vue?vue&type=template&id=1bf20a3a&scoped=true"
import script from "./OvertimeManagementComponent.vue?vue&type=script&lang=js"
export * from "./OvertimeManagementComponent.vue?vue&type=script&lang=js"
import style0 from "./OvertimeManagementComponent.vue?vue&type=style&index=0&id=1bf20a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf20a3a",
  null
  
)

export default component.exports